import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { editReader, getReaderData } from '../../api/axios';
import "./edit.css";
import { useTranslation } from 'react-i18next';
import { TextField, Button, Box, Typography, Container, Alert, FormControlLabel, Checkbox, Grid } from '@mui/material';

const EditReader = () => {
  const { t } = useTranslation('global');
  const { id } = useParams();
  const navigate = useNavigate();

  const [reader, setReader] = useState({ id: id, name: '', serial_num: '', active: false });
  const [errMsg, setErrMsg] = useState('');
  const [succ, setSucc] = useState('');

  const fetchReaderData = async () => {
    const response = await getReaderData(id);
    const readerData = {
      ...response,
      active: response.active == 1
    };
    setReader(readerData);
  };

  useEffect(() => {
    fetchReaderData();
  }, [id]);

  const handleSave = async (event) => {
    event.preventDefault();

    if (reader.name === '' || reader.serial_num === '') {
      setErrMsg(t("editReader.allFieldsAreRequired"));
      return;
    }

    const response = await editReader(reader);
    if (!response.success) {
      setErrMsg(t("editReader.errorDuringEdit"))
    }
    else {
      setSucc(t("editReader.Successful"));
      setErrMsg('');
      navigate('/readers');
    }
  };

  return (
    <Container maxWidth="sm" style={{ alignItems: "center", justifyContent: "center" }}>
      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: '#f9f9f9',
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          {t("editReader.editReader")}
        </Typography>

        <form onSubmit={handleSave} className="form">
          <Box item xs={12}>
            <TextField
              fullWidth
              id="name"
              label={t("editReader.name")}
              value={reader.name}
              onChange={(e) => setReader({ ...reader, name: e.target.value })}
              variant="outlined"
            />
          </Box>

          <Box item xs={12}>
            <TextField
              fullWidth
              id="serial_num"
              label={t("editReader.serialNumber")}
              value={reader.serial_num}
              onChange={(e) => setReader({ ...reader, serial_num: e.target.value })}
              variant="outlined"
            />
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => setReader({ ...reader, active: e.target.checked })}
                checked={reader.active}
              />
            }
            label={t("editReader.active")}
          />

          {errMsg && (
            <Box item xs={12}>
              <Alert severity="error" onClose={() => setErrMsg('')}>
                {errMsg}
              </Alert>
            </Box>
          )}
          {succ && (
            <Box item xs={12}>
              <Alert severity="success" onClose={() => setSucc('')}>
                {succ}
              </Alert>
            </Box>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
              >
                {t("editReader.save")}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Button
                fullWidth
                type="button"
                variant="contained"
                color="error"
                onClick={() => { navigate('/readers') }}
              >
                {t("editReader.cancel")}
              </Button>
            </Grid>

          </Grid>
        </form>
      </Box>
    </Container>
  );
};

export default EditReader;
